import React from "react";

const InboxLine = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 22">
        <g
            stroke={color}
            fill="none"
            fillRule="evenodd"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M14.715 1h-10a4 4 0 00-4 4v4a4 4 0 004 4h1v4l4.5-4h4.5a4 4 0 004-4V5a4 4 0 00-4-4zM11.715 16.5a2.5 2.5 0 002.5 2.5h2.5l3 3v-3h1.5a2.5 2.5 0 002.5-2.5v-2a2.5 2.5 0 00-2.5-2.5" />
        </g>
    </svg>
);

export default InboxLine;
